import { ActionAny, createActions } from 'src/utils/createActions';
import { Item } from 'src/types/entities/Item';

export type DemoUpdatePinnedActions =
    ActionAny<ReadonlyArray<Item>, ReadonlyArray<Item>>;
export const DEMO_UPDATE_PINNED_ACTIONS =
    createActions<ReadonlyArray<Item>, ReadonlyArray<Item>>('DEMO_UPDATE_PINNED');
